define('OutSystems/ClientRuntime/modules/LogTable/LogTableExtraInfoUpgrader',["require", "exports", "tslib", "../../Logger", "./LogTableInfo"], function (require, exports, tslib_1, Logger, LogTableInfo_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var LogTableExtraInfoUpgrader = {
        isNeeded: function (tx) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, tx.existsTable(LogTableInfo_1.default)];
                    case 1:
                        _a = (_b.sent());
                        if (!_a) return [3, 3];
                        return [4, tx.existsColumn(LogTableInfo_1.default.tableName, LogTableInfo_1.LOG_FIELDS.ExtraInfo)];
                    case 2:
                        _a = !(_b.sent());
                        _b.label = 3;
                    case 3: return [2, (_a)];
                }
            });
        }); },
        run: function (tx) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            var columnInfo;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Logger.trace(this, "Running upgrader for extra info column on log table.");
                        columnInfo = LogTableInfo_1.default.attributes.filter(function (col) { return col.columnName === LogTableInfo_1.LOG_FIELDS.ExtraInfo; })[0];
                        return [4, tx.addColumn(LogTableInfo_1.default, columnInfo)];
                    case 1:
                        _a.sent();
                        Logger.trace(this, "Upgrader for extra info column on log table ran successfuly.");
                        return [2];
                }
            });
        }); },
    };
    exports.default = LogTableExtraInfoUpgrader;
});
//# sourceMappingURL=LogTableExtraInfoUpgrader.js.map;
